
//Creates tooltip and makes it invisiblae
var div = d3.select(".gia-chart").append("div")
    .attr("class", "tooltip")
    .style("opacity", 0);

//Sets dimensions
var margin = {top: 0, left: 5, bottom: 5, right: 5},
  width = d3.select(".gia-chart").node().clientWidth,
  width = width - margin.left - margin.right,
  mapRatio = .65,
  height = width * mapRatio;

//Tells the map what projection to use
var projection = d3.geo.albersUsa()
  .scale(width *1.25)
  .translate([width / 2, height / 2]);

//Tells the map how to draw the paths from the projection
var path = d3.geo.path()
  .projection(projection);

var color = d3.scale.ordinal()
  .domain(["No law", "Equal", "Less", "Greater"])
  .range(["#dcdcdc", "#4bc6df", "#7d0068", "#005689"])    

//Appened svg to page
var map = d3.select(".gia-chart").append("svg")
  .style('height', height + 'px')
  .style('width', width + 'px');  

//Load the files
queue()
  .defer(d3.json, "data/usmap.json")
  .defer(d3.csv, "data/states.csv")
  .await(ready);

//Moves selection to front
d3.selection.prototype.moveToFront = function() {
  return this.each(function(){
    this.parentNode.appendChild(this);
  });
}; 

//Moves selection to back
d3.selection.prototype.moveToBack = function() { 
  return this.each(function() { 
    var firstChild = this.parentNode.firstChild; 
      if (firstChild) { 
        this.parentNode.insertBefore(this, firstChild); 
      } 
    }); 
  }; 

function ready(error, us, maptemplate) {
  if (error) throw error;  
 
  //Pair data with state id
  var dataByFIPS = {};
  maptemplate.forEach(function(d) { dataByFIPS[d.FIPS] = d.num; });

  //Pair state name with state id
  var stateByFIPS = {};
  maptemplate.forEach(function(d) { stateByFIPS[d.FIPS] = d.state; });

  //Pair cat name with state id
  var catByFIPS = {};
  maptemplate.forEach(function(d) { catByFIPS[d.FIPS] = d.cat; });

  //Append states
  map.append("g")
    .attr("class", "states")
    .selectAll("path")
    .data(topojson.feature(us, us.objects.states).features)
    .enter().append("path")
    .attr("d", path)
    .style("fill", function(d) { return color(catByFIPS[d.id]); })

    //Hovers
    .on("mouseover", function(d) {
      var sel = d3.select(this);
        sel.moveToFront();
      d3.select(this)
        .transition().duration(300).style({'opacity': 1, 'stroke': '#333333', 'stroke-width': 1.5});
      div.transition().duration(300)
        .style("opacity", 1)
      div.text(stateByFIPS[d.id] + "'s minimum wage is $" +dataByFIPS[d.id]);
    })

    .on("mouseout", function() {
      var sel = d3.select(this);
        sel.moveToBack();
      d3.select(this)
        .transition().duration(300).style({'opacity': 1, 'stroke': 'white', 'stroke-width': 1});
      div.transition().duration(300)
        .style("opacity", 0);
    })

  //RESPONSIVENESS
  d3.select(window).on('resize', resize);

  function resize() {

    var w = d3.select(".gia-chart").node().clientWidth;

    //Adjust things when the window size changes
    width = w - margin.left - margin.right;
    height = width * mapRatio;
    
    //Update projection
    var newProjection = d3.geo.albersUsa()
      .scale(width*1.25)
      .translate([width / 2, height / 2]);

    //Update path
    path = d3.geo.path()
      .projection(newProjection);    

    //Resize the map container
    map
      .style('width', width + 'px')
      .style('height', height + 'px');

    //Resize the map
    map.selectAll("path").attr('d', path);
  }
}